import { useContext } from 'react';

import TabsContext, { TabsContextData } from './TabsContext';

export default function useTabs(): TabsContextData {
    return useContext(TabsContext);
}
